import React from 'react';

interface ShimmerEffectProps {
  className?: string;
  children?: React.ReactNode;
}

const ShimmerEffect: React.FC<ShimmerEffectProps> = ({ className = '', children }) => {
  return (
    <div className={`animate-pulse ${className}`}>
      {children}
    </div>
  );
};

// User card shimmer
export const UserCardShimmer: React.FC = () => (
  <ShimmerEffect>
    <div className="space-y-2">
      {[...Array(8)].map((_, i) => (
        <div key={i} className="p-3 rounded-lg border border-gray-200 dark:border-[#1F2937] bg-gray-50 dark:bg-[#1F2937]">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-gray-300 dark:bg-gray-600"></div>
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-3/4"></div>
              <div className="h-3 bg-gray-300 dark:bg-gray-600 rounded w-1/2"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </ShimmerEffect>
);

// Usage stats shimmer
export const UsageStatsShimmer: React.FC = () => (
  <ShimmerEffect>
    <div className="space-y-6">
      {/* Stats cards shimmer */}
      <div className="bg-white dark:bg-black border border-gray-200 dark:border-[#1F2937] rounded-xl p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="h-6 bg-gray-300 dark:bg-gray-600 rounded w-48"></div>
          <div className="h-10 bg-gray-300 dark:bg-gray-600 rounded w-32"></div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="text-center p-4 bg-gray-50 dark:bg-[#1F2937] rounded-lg">
              <div className="h-8 bg-gray-300 dark:bg-gray-600 rounded w-16 mx-auto mb-2"></div>
              <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-20 mx-auto"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Monthly usage table shimmer */}
      <div className="bg-white dark:bg-black border border-gray-200 dark:border-[#1F2937] rounded-xl p-6">
        <div className="h-6 bg-gray-300 dark:bg-gray-600 rounded w-48 mb-4"></div>
        <div className="space-y-3">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="grid grid-cols-4 gap-4">
              <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded"></div>
              <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded"></div>
              <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded"></div>
              <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Credit history shimmer */}
      <div className="bg-white dark:bg-black border border-gray-200 dark:border-[#1F2937] rounded-xl p-6">
        <div className="h-6 bg-gray-300 dark:bg-gray-600 rounded w-48 mb-4"></div>
        <div className="space-y-3">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="flex items-center justify-between p-3 bg-gray-50 dark:bg-[#1F2937] rounded-lg">
              <div className="flex-1 space-y-2">
                <div className="flex items-center gap-2">
                  <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-16"></div>
                  <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-24"></div>
                </div>
                <div className="h-3 bg-gray-300 dark:bg-gray-600 rounded w-3/4"></div>
                <div className="h-3 bg-gray-300 dark:bg-gray-600 rounded w-1/2"></div>
              </div>
              <div className="w-20">
                <div className="h-3 bg-gray-300 dark:bg-gray-600 rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </ShimmerEffect>
);

export default ShimmerEffect;
